module.exports = __webpack_public_path__ + "img/ind.e4ab7bd0.svg";